/**
 * An enum to represent all the valid Coin Denominations in Pocket Network
 */
export enum CoinDenom {
    Upokt = 'Upokt',
    Pokt = 'Pokt'
}
